export function StatCard({ label, value, note }: { label: string; value: string | number; note?: string }) {
  const valueSize =
    typeof value === "string" && value.length > 12 ? "text-base" :
    typeof value === "string" && value.length > 6  ? "text-xl" :
    "text-3xl";
  return (
    <div className="rounded-3xl border border-stone-200 bg-white p-5 shadow-sm" data-testid={`stat-card-${label.toLowerCase().replace(/\s+/g, '-')}`}>
      <p className="text-sm text-stone-500">{label}</p>
      <p className={`mt-2 font-semibold text-stone-900 leading-snug ${valueSize}`}>{value}</p>
      {note && <p className="mt-2 text-xs text-stone-500">{note}</p>}
    </div>
  );
}
